var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "language_setting" } }, [
    _c("section", { staticClass: "menu_ctrl" }, [
      _c("span", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.$t("__language_setting.top_hint")))
      ])
    ]),
    _vm._v(" "),
    _vm.init_items.length > 0
      ? _c(
          "div",
          { staticClass: "language_treeview" },
          [
            _c("TreeView", {
              attrs: {
                init_items: _vm.init_items,
                checked_selectors: _vm.checked_selectors,
                init_opened_layers: _vm.init_opened_layers,
                check_function: _vm.change_language
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }